/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Wed Dec 27 2023
 **/
/* eslint-disable @typescript-eslint/no-explicit-any */

import { UserItem, VoiceCallCommander, VoiceCallResponder } from "@/frameworks/core/components";
import { useCommandConsumer } from "@/frameworks/core/hooks";
import { colors } from "@/frameworks/core/styles";
import { Column, Divider, Icon, Row, Typography } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";

export default function VoiceCallUserModal({ onHide, roomID }: { onHide: () => void; roomID: string }) {
	const commander = useCommandConsumer<VoiceCallResponder, VoiceCallCommander>("VoiceCall", {});
	const members = commander.command?.get_members(roomID) ?? [];
	return (
		<Column
			style={{
				width: "320px",
				height: "325px",
				background: colors.neutral_00_100,
				borderRadius: "12px",
				boxShadow: "0px 12px 20px 0px rgba(0, 0, 0, 0.20)"
			}}
		>
			<Row style={{ width: "100%", padding: "14px 12px 12px 24px" }} horizonAlign="distribute">
				<Column style={{ width: "100%" }}>
					<Typography typoSize="Head6">{_T("보이스챗 참여자")}</Typography>
					<Typography typoSize="Body4" typoColor="neutral_80_100">
						{_T("{{count}}명 참여중", { count: members?.length })}
					</Typography>
				</Column>
				<Icon name="Close24" size={24} onClick={onHide} style={{ cursor: "pointer" }} />
			</Row>
			<Divider type="line" />
			<Column
				style={{
					padding: "8px 20px 20px",
					width: "100%",
					height: "100%",
					marginBottom: "10px",
					overflow: "auto"
				}}
			>
				{members.map((user: any) => (
					<UserItem id={user.id} key={user.id} isUserButtonStyle={false}>
						{user.micState === "on" ? <Icon name="MicOn24" /> : <Icon name="MicOff24" />}
					</UserItem>
				))}
			</Column>
		</Column>
	);
}
